import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const LanguageSelect = ({ testid = "language-select", className = "" }) => {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find((l) => i18n.language?.startsWith(l.code))?.code || "sv";

  return (
    <Select value={current} onValueChange={(v) => i18n.changeLanguage(v)}>
      <SelectTrigger data-testid={testid} className={`h-10 gap-2 bg-white ${className}`}>
        <Globe className="h-4 w-4 text-slate-500" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-white">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelect;
